import { useQuery } from '@tanstack/react-query';
import { GOVERNMENT_CASE_NUMBERS_KEY } from '../../utils/constants/queryKeys';
import { getGovernmentCaseNumbers } from '../services/fn-api/Cases';

export const useGetGovernmentCaseNumbers = (caseId: number) => {
  return useQuery({
    queryKey: [GOVERNMENT_CASE_NUMBERS_KEY, caseId],
    queryFn: () => getGovernmentCaseNumbers(caseId),
    enabled: !!caseId,
  });
};
